'use client'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { useState } from 'react'
import { useLanguage } from '@/app/(frontend)/providers/LanguageProvider'

export function FlowButton({
  text = 'Modern Button',
  width = 'max-w-[220px] md:max-w-[140px]',
  height = 'h-[45px]',
}: {
  text?: string
  width?: string
  height?: string
}) {
  const [bouncing, setBouncing] = useState(false)
  const [bounceOut, setBounceOut] = useState(false)
  const { language } = useLanguage()
  const isArabic = language === 'ar'

  const handleMouseEnter = () => {
    setBounceOut(false)
    setBouncing(true)
    setTimeout(() => setBouncing(false), 600)
  }

  const handleMouseLeave = () => {
    setBouncing(false)
    setBounceOut(true)
    setTimeout(() => setBounceOut(false), 600)
  }

  const textAnim = bouncing
    ? isArabic
      ? 'animate-bounceTextInRtl'
      : 'animate-bounceTextIn'
    : bounceOut
      ? isArabic
        ? 'animate-bounceTextOutRtl'
        : 'animate-bounceTextOut'
      : ''

  const circleAnim = bouncing
    ? 'animate-bounceCircleIn'
    : bounceOut
      ? 'animate-bounceCircleOut'
      : ''

  return (
    <button
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={`group relative flex items-center scale-[0.8] md:scale-100 gap-1 px-8  text-sm font-light text-[#ee3e25] cursor-pointer overflow-hidden border-[1.7px] border-[#ee3e25]/90 bg-transparent transition-all duration-[600ms] ease-[cubic-bezier(0.23,1,0.32,1)] hover:border-transparent hover:text-white hover:rounded-[7.5px] active:scale-[0.95] ${width} ${height} `}
    >
      <div
        className={`whitespace-nowrap relative z-[1] flex items-center justify-center gap-3 md:gap-2 w-fit transition-all duration-700 ease-[cubic-bezier(0.34,1.56,0.64,1)] ${isArabic ? 'translate-x-10 group-hover:translate-x-4 mr-3' : '-translate-x-10 group-hover:-translate-x-4'} ${textAnim}`}
      >
        {/* Left Arrow */}
        {isArabic ? (
          <ArrowLeft
            strokeWidth={1.4}
            className={`size-5 z-[9]  stroke-white opacity-0 group-hover:opacity-100`}
          />
        ) : (
          <ArrowRight
            strokeWidth={1.4}
            className={`size-5 z-[9]  stroke-white opacity-0 group-hover:opacity-100`}
          />
        )}

        {/* Text */}
        <span className=" text-[20px] md:text-sm group-hover:text-white font-light ml-5 md:ml-0">{text}</span>

        {/* Right Arrow */}
        {isArabic ? (
          <ArrowLeft
            strokeWidth={1.4}
            className={`size-5 z-[9] stroke-[#ee3e25] fill-none group-hover:opacity-0`}
          />
        ) : (
          <ArrowRight
            strokeWidth={1.4}
            className={`size-6 md:size-5 z-[9] stroke-[#ee3e25] fill-none group-hover:opacity-0`}
          />
        )}
      </div>

      {/* Circle Background */}
      <span
        className={`absolute top-1/2 left-1/2 z-0 -translate-x-1/2 -translate-y-1/2 size-[200px] rounded-full bg-[#ee3e25] opacity-0 group-hover:opacity-100 transition-opacity duration-[800ms] ease-[cubic-bezier(0.19,1,0.22,1)] ${circleAnim}`}
      />
    </button>
  )
}
